/**
 * O CPF que o operador DIGITOU na busca, levado ate' a ficha.
 *
 * A ficha recarrega o servidor sozinha, e recarregava so' pela matricula. Pela
 * regra da API (`cpfDaFichaVisivel`), busca por matricula de quem nao e' cliente
 * nao devolve o CPF completo — entao o operador digitava o CPF, abria a ficha e
 * via o CPF mascarado, sem olho que o mostrasse. Com o CPF digitado, a ficha
 * busca por CPF + matricula e a API devolve o CPF, que o banco ja' tinha.
 *
 * Vai no `state` da navegacao, nunca na URL: URL vai para historico, log de
 * proxy e print de tela.
 */
export interface EstadoDaFicha {
  cpfBuscado?: string;
}

export function estadoDaFicha(cpf: string | undefined): EstadoDaFicha | undefined {
  const digitos = (cpf ?? "").replace(/\D/g, "");
  return digitos.length === 11 ? { cpfBuscado: digitos } : undefined;
}

export function cpfBuscadoDo(state: unknown): string | undefined {
  const cpf = (state as EstadoDaFicha | null)?.cpfBuscado;
  return typeof cpf === "string" && /^\d{11}$/.test(cpf) ? cpf : undefined;
}
